import InfoPage from "../../components-v2/info/InfoPage";
import { InfoSection } from "../../components-v2/info/InfoContent";
import React from "react";
import MetaElement from "../../components/elements/MetaElement";

const DetaliiLivrare = () => {
  return (
    <InfoPage title="Livrare și plată">
      <MetaElement pageId="info/detalii-livrare" />

      <InfoSection id="info-delivery" title="Livrare">
        <p>
          Toate comenzile înregistrate vor fi livrate prin intermediul
          serviciilor de curierat rapid, cu exceptia cazului in care este
          selectata optiunea "Ridicare Personala"
        </p>

        <p>
          Taxa de livrare în țară este de <strong>15 Lei</strong> per comanda, sau gratuit la
          comenzi în valoare de <strong>190 Lei</strong> sau mai mult.{" "}
        </p>

        <p>
          Termenul de livrare este de <strong>1-3 zile lucrătoare</strong> de la plasarea
          comenzii. În zilele de weekend (sâmbătă și duminică) nu se livrează.
        </p>

        <p>
          În momentul expedierii coletului, veți fi notificat prin e-mail și/sau
          SMS. De asemenea, puteți verifica oricând statusul comenzii pe Site în
          secțiunea "Comenzile mele".
        </p>

        <p>
          Agentul companiei de curierat vă va contacta telefonic pentru a vă
          livra coletul. În cazul în care acesta nu vă găsește la adresă, și nu
          puteți fi contactat(ă) telefonic, coletul se va întoarce la centrul de
          livrare. La centrul de livrare, firma de curierat va stabili o nouă
          dată pentru a expedia coletul.
        </p>

        <p>Coletul va fi păstrat maxim 5 (cinci) zile la firma de curierat.</p>

        <p>
          Pentru TRANSPORT INTERNAȚIONAL vă rugăm să ne contactați la adresa de
          e-mail <a href="mailto:contact@krit.ro">contact@krit.ro</a>
        </p>
      </InfoSection>

      <InfoSection id="info-payment" title="Plată">

        <p>Plata se poate efectua prin următoarele modalități:</p>

        <ul>
          <li>Online prin card bancar</li>
          <li>Ramburs la curier</li>
          <li>Transfer bancar</li>
          <li>
            Cash sau card bancar la sediu (doar în cazul comenzilor ridicate
            personal)
          </li>
        </ul>

        <p>
          In cazul optiunii de plata " Online prin card bancar " veti fi
          redirectionat catre pagina securizata a procesatorului de plati unde
          veti completa un formular cu informatiile despre cardul dumneavoastra.
        </p>

        <p>
          Platile cu carduri de credit/debit emise sub sigla Visa si MasterCard
          (Visa/Visa Electron si MasterCard/Maestro) se efectuaeaza prin
          intermediul sistemului "3-D Secure" dezvoltat de organizatiile de
          carduri Visa/MasterCard si care asigura tranzactiilor on-line acelasi
          nivel de securitate ca al celor realizate la bancomat sau in mediul
          fizic, la comerciant.
        </p>

        <p>
          "3-D Secure" asigura in primul rand ca nici o informatie legata de
          cardul dumneavoastra nu este transferata sau stocata, la nici un
          moment de timp, pe serverele magazinului virtual.
        </p>

        <p>
          Important de stiut! - Pentru platile prin card bancar nu este perceput
          nici un comision de la detinatorul de card!
        </p>
      </InfoSection>

    </InfoPage>
  );
};

export default DetaliiLivrare;
